import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from './ui/dialog';
import { Phone, Linkedin } from 'lucide-react';

const ContactModal = ({ isOpen, onClose, portfolioData }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-slate-950 border-slate-800 text-white max-w-md">
        <DialogHeader>
          <DialogTitle className="text-3xl font-bold">Get In Touch</DialogTitle>
          <DialogDescription className="text-slate-400">
            Feel free to reach out through any of these channels
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 mt-6">
          {/* Phone */}
          <a 
            href={`tel:${portfolioData.personal.phone}`}
            className="flex items-center gap-4 p-4 bg-slate-900 rounded-lg hover:bg-slate-800 transition-colors group"
          >
            <div className="flex-shrink-0 w-12 h-12 bg-blue-950 rounded-full flex items-center justify-center group-hover:bg-blue-900 transition-colors">
              <Phone className="text-blue-400" size={24} />
            </div>
            <div>
              <p className="text-sm text-slate-400">Phone</p>
              <p className="text-white font-medium">{portfolioData.personal.phone}</p>
            </div>
          </a>
          
          {/* LinkedIn */}
          <a 
            href={`https://${portfolioData.personal.linkedin}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-4 p-4 bg-slate-900 rounded-lg hover:bg-slate-800 transition-colors group"
          >
            <div className="flex-shrink-0 w-12 h-12 bg-blue-950 rounded-full flex items-center justify-center group-hover:bg-blue-900 transition-colors">
              <Linkedin className="text-blue-400" size={24} />
            </div>
            <div>
              <p className="text-sm text-slate-400">LinkedIn</p>
              <p className="text-white font-medium">linkedin.com/in/kbhatia03</p>
            </div>
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ContactModal;
